export function toNumber(value, defaultValue=0) {
    let v;
    return isFinite(value) && !isNaN(v = parseFloat(value)) ? v : defaultValue;
}
